import React from 'react'
import * as UI from 'ui'
import * as Displays from 'support/displays'
import { ForEachModel, ValueToCollection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { Translation } from '@morningtrain/react-translations'

export default function GuestCountTableByDepartment () {
  return (
    <ValueToCollection name='table'>
      <ForEachModel>
        <UI.Card tight className='pt-6 sm:pt-10'>
          <UI.CardHeader withPadding>
            <UI.SecondaryHeading>
              <Displays.Text name='key' />
            </UI.SecondaryHeading>
          </UI.CardHeader>
          <ValueToCollection name='collection'>
            <Table striped withFooter>
              <Columns.Text
                name='name'
                label={<Translation name='generic.department' />}
                footer={<Translation name='generic.total' />}
              />
              <Columns.Number
                name='guestcount'
                decimals={0}
                aggregate='sum'
                alignment='right'
                label={<Translation name='generic.guest_count' />}
              />
              <Columns.Number
                name='guestcount_ly'
                decimals={0}
                aggregate='sum'
                label={(
                  <span>
                    <Translation name='generic.guest_count' /> (LY)
                  </span>
                )}
                alignment='right'
              />
              <Columns.Percentage
                name='guestcount_change'
                badBelow={0}
                decimals={0}
                positiveColor='green'
                alignment='right'
                label={(
                  <span>
                    <Translation name='generic.change' /> (LY)
                  </span>
                )}
                footer={(
                  <Displays.AggregateChange
                    name='guestcount'
                    outOfName='guestcount_ly'
                    display={(
                      <Displays.Percentage
                        badBelow={0}
                        decimals={0}
                        positiveColor='green'
                      />
                    )}
                  />
                )}
              />
            </Table>
          </ValueToCollection>
        </UI.Card>
      </ForEachModel>
    </ValueToCollection>
  )
}
